import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Style from './index.css';
import Player from '@ifeng/three_terminal/es/pc/video/output/pcVideo.jsx';
import { getModuleByName } from '@src/common/utils';

const VideoTabs = (props) => {
    const { content } = props;

    const [ tabIndex, setTabIndex ] = useState(0);
    const [ videoPlayIndex, setVideoPlayIndex ] = useState(0);

    const playIndexRef = useRef(0);

    const videoList1 = getModuleByName(content, '完整视频')?.data.articleList;
    const videoList2 = getModuleByName(content, '精彩片段')?.data.articleList;

    return (
        <div className={Style.wrap}>
            {/* eslint-disable no-nested-ternary */}
            <div className={Style.videoPart}>
                {
                    (tabIndex === 0 ? videoList1 : videoList2).length > 0 &&

                    <Player
                        key={tabIndex}
                        videoConfig={(tabIndex === 0 ? videoList1 : videoList2).length > 0 ? (tabIndex === 0 ? videoList1 : videoList2) : [{ poster: '' }]}
                        playermsg={{
                            width: 730,
                            height: 410,
                            controls: true,
                            playerHooks: ({ changePlayIndex }) => {
                                playIndexRef.current = changePlayIndex;
                            },
                            playerEventTrigger: (player) => {
                                player.on('ended', () => {
                                    if (videoPlayIndex < (tabIndex === 0 ? videoList1 : videoList2).length - 1) {
                                        setVideoPlayIndex(videoPlayIndex + 1);
                                        playIndexRef.current(videoPlayIndex + 1);
                                    }
                                });
                                player.on('canplay', () => {
                                    player.play();
                                });
                            }
                        }}
                    />
                }
            </div>
            <div className={Style.rightPart}>
                <div className={Style.tabWp}>
                    <div className={`${Style.tab} ${tabIndex === 0 ? Style.active : ''}`} onClick={() => setTabIndex(0)}>完整视频</div>
                    <div className={`${Style.tab} ${tabIndex === 1 ? Style.active : ''}`} onClick={() => setTabIndex(1)}>精彩片段</div>
                </div>
                <div className={Style.articleList}>
                    {
                        (tabIndex === 0 ? videoList1 : videoList2).map((video, index) => {
                            return (
                                <div className={Style.article} key={index} onClick={() => playIndexRef.current(index)}>
                                    <img className={Style.icon} src="https://x2.ifengimg.com/fe/shank/custom/play_mini_ac2.14c8ff6e.png" alt="" />
                                    <div className={Style.title}>{video.title}</div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
};

VideoTabs.propTypes = {
    content: PropTypes.object
};

export default errorBoundary(VideoTabs);
